<template>
  <button
    v-loading="reporting"
    class="btn btn-wd btn-fill btn-tertiary"
    @click="loadingReport"
  >
    Gerar relatório geral simplificado: {{eventLabel}}
  </button>
</template>
<script>
  import blobUtils from 'blob-util'
  import downloadJs from 'downloadjs'
  import CouchdbClass from 'src/services/CouchdbClass'
  import LGPD from 'src/services/LGPD'
  // import {flattenObject} from 'src/services/Helper'
  import {mapGetters, mapActions} from 'vuex'
  import swal from 'sweetalert2'


  export default {
    name: 'global-ranking-report-simplified',

    props: {
      events: {
        required: true
      },
      csvSeparator: {
        required: true,
        default: ';'
      },
      enablePartial: {
        default: false
      },
      enableLGPD: {
        default: false
      }
    },

    data () {
      return {
        eventsData: {},
        event: {},
        options: {
          include_docs: true,
          inclusive_end: true,
          reduce: false,
          skip: 0
        },
        reporting: false,
        loadingTickets: true,
        loadingLamps: true,
        loadingSurveys: true,
        customersIds: [],
        reported: false,
        reportData: {},
        moreThanOneTicket: [],
        lampsCounterCustomer: {}
      }
    },

    computed: {
      ...mapGetters('users', ['usersIdName']),
      ...mapGetters('project', ['project']),

      eventLabel () {
        return localStorage.getItem('eventLabel') || 'Ações'
      },

      customersCouch: function () {
        return new CouchdbClass({connection: 'default', collection: 'customers'})
      },

      eventsCouch: function () {
        return new CouchdbClass({connection: 'default', collection: 'events'})
      },

      ticketsCouch: function () {
        return new CouchdbClass({connection: 'default', collection: 'tickets'})
      },

      lampsCouch: function () {
        return new CouchdbClass({connection: 'default', collection: 'lamps'})
      },

      stocksCouch: function () {
        return new CouchdbClass({connection: 'default', collection: 'stocks'})
      },

      surveysCouch: function () {
        return new CouchdbClass({connection: 'surveys', collection: 'surveys'})
      },

      manufacturersCouch: function () {
        return new CouchdbClass({connection: 'config', collection: 'manufacturers'})
      },

      usersCouch: function () {
        return new CouchdbClass({connection: 'config', collection: 'users'})
      },

      csvHeaders () {
        return {
          events: {
            'reference': 'Referência',
            'city': 'Município'
          },
          customers: {
            'uc': 'UC',
            'cpf': 'CPF',
            'holder': 'Titular',
            'phone1': 'Telefone 01',
            'phone2': 'Telefone 02',
            'city': 'Cidade',
            'userId': 'Atendente'
          },
          tickets: {
            'createdAt': 'Data de cadastro',
            'winner': 'Cliente comtemplado?'
          },
          lamps: { // O valor # será substituído por um inteiro que servirá de indice após o flatten
            'changed': 'Trocou lampadas?',
            'count': 'Quantidade de lampadas?'
          }
        }
      },

      loading () {
        return this.loadingLamps && this.loadingTickets && this.loadingSurveys
      }
    },

    methods: {
      ...mapActions('project', {fetchProject: 'fetchOne'}),

      mapKeyArrayToObject ({dataArray, keyObject, reportField}) {
        for (let currentValue of dataArray) {
          let keyObj = ''
          for (let key of keyObject.split('.')) {
            keyObj = keyObj === '' ? currentValue[key] : keyObj[key]
          }

          if (!this.reportData[this.event._id][reportField].hasOwnProperty(keyObj)) {
            this.reportData[this.event._id][reportField][keyObj] = []
          }

          if (this.reportData[this.event._id][reportField][keyObj].find(item => item._id === currentValue._id)) {
            continue
          }

          this.reportData[this.event._id][reportField][keyObj].push(currentValue)
        }
        // console.log(this.reportData[this.event._id])
      },

      loadingReport () {
        swal({
          title: 'Informações',
          text: 'Estamos gerando o relatório. Por favor aguarde e não recarregue ou feche a página.',
          type: 'info',
          showConfirmButton: false,
          allowOutsideClick: false,
          onOpen: async () => {
            swal.showLoading()
            await this.runReport()
            swal.hideLoading()
            swal.close()
          }
        })
          .catch(err => {
            console.log(err)
          })
      },

      async runReport () {
        this.reporting = true
        this.$emit('progress', {current: 0, total: 0})
        this.resetValues()
        let report = this.addHeaders()
        for (let e of this.events) {
          this.event = JSON.parse(JSON.stringify(e))
          if (!this.reportData.hasOwnProperty(e._id)) {
            this.defineReportDataObject(e)
          }
          await this.fetchData()
          report += await this.handleReport()
        }
        report += this.addFooter()
        this.download(report)
        this.reporting = false
      },

      async fetchData () {
        try {
          await this.fetchTickets()
          await this.fetchLamps()
          await this.fetchCustomers()
          await this.fetchUsers()
        } catch (e) {
          console.log(e)
        }

        return true
      },

      fetchUsers () {
        return this.usersCouch.limit(999999).get().then(result => {
          return this.mapKeyArrayToObject({dataArray: result, keyObject: '_id', reportField: 'users'})
        })
      },

      fetchTickets () {
        return this.ticketsCouch.where('eventId', this.event._id).limit(99999999).get().then(result => {
          return this.mapKeyArrayToObject({dataArray: result, keyObject: 'customerId', reportField: 'tickets'})
        })
      },

      fetchLamps () {
        return this.lampsCouch.where('eventId', this.event._id).limit(99999999).get().then(result => {
          return this.mapKeyArrayToObject({dataArray: result, keyObject: 'customer.id', reportField: 'lamps'})
        })
      },

      fetchCustomers () {
        const idsCustomers = Object.keys(this.reportData[this.event._id].tickets)
          .map(item => Object.assign({}, {id: item}))
          .concat(Object.keys(this.reportData[this.event._id].lamps).map(item => Object.assign({}, {id: item})))
        return this.customersCouch._bulkGet(idsCustomers).then(result => {
          return this.mapKeyArrayToObject({dataArray: result, keyObject: '_id', reportField: 'customers'})
        })
      },

      resetValues () {
        this.reporting = false
        this.loadingTickets = true
        this.loadingLamps = true
        this.loadingSurveys = true
        this.customersIds = []
        this.reported = false
        this.reportData = {}
        this.moreThanOneTicket = []
        this.lampsCounterCustomer = {}
      },

      async handleReport () {
        if (this.moreThanOneTicket.length > 0) {
          // Tabela de código de erros está no README.md
          this.$notify({
            message: '[ERROR: 409] Ocorreu um erro ao gerar o relatório. Entre em contato com o suporte e informe o código de erro 409.',
            type: 'danger',
            timeout: 10000
          })
          return false
        }

        try {
          if (!this.reporting) {
            return this.makeReport()
          }
        } catch (e) {
          this.$notify({
            message: 'Ocorreu algum problema ao gerar o relatório. Tente novamente, ou espere alguns minutos para tentar. Se persistir, entre em contato com o suporte.',
            type: 'danger',
            timeout: 10000
          })
          console.log(e)
        }
      },

      addFooter () {
        return `\n"Arquivo gerado em: "${this.csvSeparator}"${this.$moment(new Date()).format('DD-MM-YYYY HH:mm:ss')}"`
      },

      makeReport () {
        const bodies = this.addBodies()
        // console.log('made body?', bodies)
        if (!bodies) {
          this.$notify({message: 'Dados insuficientes para gerar o relatório.', type: 'info'})
          return false
        }

        return bodies
      },

      download (report) {
        let blob = blobUtils.createBlob([report], {type: 'text/plain'})
        let now = this.$moment(new Date()).format('DD-MM-YYYY_HH-mm-ss')
        let reportType = this.event.status === 2 ? 'Relatório_Simplificado_Geral' : 'Relatório_Simplificado_Parcial'
        let filename = `${reportType}_${now}`
        this.reported = true
        downloadJs(blob, `${filename}.csv`)
      },

      addHeaders () {
        let csv = this.addHeader(this.csvHeaders)
        return csv + '\n'
      },

      addHeader (headers) {
        let csv = ''
        Object.keys(headers).forEach((header) => {
          if (headers[header] !== null && typeof headers[header] === 'object') {
            csv += this.addHeader(headers[header])
          } else {
            csv += `${headers[header]}${this.csvSeparator}`
          }
        })
        return csv
      },

      addBodies () {
        let actualReportData = this.reportData[this.event._id]
        let csv = ''
        let current = 0
        if (Object.keys(this.reportData[this.event._id].customers).length < 1) {
          this.reporting = false
          this.$notify({message: 'Não há clientes para este evento.', type: 'warning'})
          return ''
        }

        for (let customerId in actualReportData.customers) {
          csv += this.addEventReport(this.event)

          if (actualReportData.customers.hasOwnProperty(customerId)) {
            csv += this.addCustomerReport(actualReportData.customers[customerId][0])
          } else {
            csv += this.addCustomerReport(undefined)
          }

          if (actualReportData.tickets.hasOwnProperty(customerId)) {
            csv += this.addTicketReport(actualReportData.tickets[customerId][0])
          } else {
            csv += this.addTicketReport(undefined)
          }

          if (actualReportData.lamps.hasOwnProperty(customerId)) {
            csv += this.addLampsReport(actualReportData.lamps[customerId])
          } else {
            csv += this.addLampsReport(undefined)
          }

          csv += this.csvSeparator + '\n'

          ++current
          this.$emit('progress', {current, total: actualReportData.customers.length})
        }

        return csv
      },

      addCustomerReport (obj) {
        let csv = ''
        for (let field in this.csvHeaders.customers) {
          if (
            ['street', 'number', 'neighborhood', 'city', 'zip', 'complement'].indexOf(field) !== -1 &&
            obj.hasOwnProperty('address') &&
            obj.address.hasOwnProperty(field)
          ) {
            csv += `"${obj['address'][field]}"${this.csvSeparator}`
            continue
          }
          csv += this.addDefaultCsv(field, obj)
        }
        return csv
      },

      addEventReport (obj) {
        let csv = ''
        for (let field in this.csvHeaders.events) {
          csv += this.addDefaultCsv(field, obj)
        }
        return csv
      },

      addTicketReport (obj) {
        // console.log('test', obj)
        return this.addDefaultReport(Object.keys(this.csvHeaders.tickets), obj)
      },

      addLampsReport (lamps) {
        if (!lamps) {
          return `Não${this.csvSeparator}-${this.csvSeparator}`
        }
        let csv = ''
        let count = lamps.reduce((sum, curr) => {
          sum += curr.items.length
          return sum
        }, 0)
        csv += `Sim${this.csvSeparator}`
        csv += `${count}${this.csvSeparator}`

        // for (let lamp of lamps) {
        //   let item = flattenObject(lamp)
        //   item.count = lamp.items.length
        //   for (let field of Object.keys(this.csvHeaders.lamps)) {
        //     csv += this.addDefaultCsv(field, item)
        //   }
        // }

        return csv
      },

      addDefaultReport (fields, obj) {
        let csv = ''
        for (let field of fields) {
          csv += `${this.addDefaultCsv(field, obj)}`
        }
        return csv
      },

      addDefaultCsv (key, obj) {
        if (this.fieldInvalid(key, obj)) {
          return `"-"${this.csvSeparator}`
        }

        if (key === 'userId' && this.reportData[this.event._id].users.hasOwnProperty(obj[key])) {
          return `"${this.reportData[this.event._id].users[obj[key]][0].name}"${this.csvSeparator}`
        }

        if (this.fieldDate(key)) {
          return this.addDate(key, obj)
        }

        if (this.fieldBoolean(key, obj)) {
          return this.addBoolean(key, obj)
        }

        if (this.fieldNumber(key)) {
          return this.addNumber(key, obj)
        }

        if (this.enableLGPD) {
          switch (key) {
            case 'holder':
              return `"${LGPD.obfuscateString(obj[key])}"${this.csvSeparator}`
            default:
              break
          }
        }

        return `"${obj[key]}"${this.csvSeparator}`
      },

      addDate (key, obj) {
        if (!obj[key]) return '"-"' + this.csvSeparator
        return `${this.$moment(obj[key])
              .format('DD-MM-YYYY HH:mm:ss')}${this.csvSeparator}`
        // return `"${this.$moment(obj[key]).format('L')} ${this.$moment(obj[key]).format('LTS')}"` + this.csvSeparator
      },

      addBoolean (key, obj) {
        if (obj[key] && obj[key].toString() === 'true') {
          return '"Sim"' + this.csvSeparator
        }
        return '"Não"' + this.csvSeparator
      },

      addNumber (key, obj) {
        return `"${obj[key].replace('.', ',')}"${this.csvSeparator}`
      },

      fieldDate (key) {
        let fields = [
          'endDate',
          'startDate',
          'createdAt',
          'dateTimeCeremony',
          'documentedAt',
          'dateInvoice',
          'dateInvoicePowerCompany',
          'updatedAt'
        ]
        for (let field of fields) {
          if (key.includes(field)) {
            return true
          }
        }

        return false
      },

      fieldInvalid (key, obj) {
        return !obj || !obj.hasOwnProperty(key) || typeof obj[key] === 'undefined'
      },

      fieldBoolean (key, obj) {
        return obj[key] === null || obj[key].toString() === 'true' || obj[key].toString() === 'false' || key.includes(
          'drawn') || key.includes('checkIn')
      },

      fieldNumber (key) {
        return key.includes('score')
      },

      getUserIdName (id) {
        return this.usersIdName.hasOwnProperty(id) ? this.usersIdName[id] : 'deletado'
      },

      defineReportDataObject (event) {
        if (this.reportData.hasOwnProperty(event._id)) return

        this.reportData[event._id] = {
          customers: {},
          tickets: {},
          surveys: {},
          lamps: {},
          manufacturers: {},
          stocks: {},
          users: {}
        }
      }
    },

    mounted () {
      this.fetchProject('config')
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Reports/GlobalRankingReportSimplified.vue